import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import style from "./SignUp.module.scss";
import StepOne from '../../Components/Signin/SignUp/StepOne/StepOne';
import StepTwo from '../../Components/Signin/SignUp/StepTwo/StepTwo';
import rightArrow from '../../assets/icons/right-arrow.svg';
import Logo from "../../assets/Logo/MobishaLogoWhiteStroke.svg";
import Carousel from '../../Components/Signin/carousel/carousel'

const SignUp = (props) => {
    const [step, setStep] = useState('stepone')

    useEffect(() => {
        let URL = props.location.pathname.slice(8,)
        setStep(URL)
    }, [props.location.pathname]);
    const backHandler = () => {
        props.history.push("/signup/stepone")
        setStep("stepone")
    }

    return (
        <React.Fragment>
            <div className={style.signUpWrapper}>
                <div className={style.logoWrapper}>
                    <div className={style.logo}></div>
                </div>
                <div className={style.signUpRightBg}>
                    {step === "stepone" && <StepOne />}
                    {step === "steptwo" && <StepTwo backToStepOne={backHandler} />}
                </div>
                <div className={style.signUpLeftBg}>
                    <div className={style.flexWrapper}>
                        <div className={style.signUpLogo}>
                            <img alt="logo" src={Logo} />
                            <h2 className={style.logoText}>موبیـشـا</h2>
                        </div>
                        <div className={style.carouselWrapper}>
                            <Carousel />
                        </div>
                        <a className={style.link} href="https://mobisha.ir/">
                            <img src={rightArrow} alt=''></img>
                            بازگشت به صفحه اصلی
                        </a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(SignUp);